/* Legeldle főoldal – nyitókép diái (2026-11-01): áttűnés, pöttyök, nyilak, húzás mobilon, automatikus léptetés
   (rámutatáskor, fókuszban és a téma-szerkesztőben megáll; csökkentett mozgásnál nem lép magától). */
(function () {
  if (customElements.get('lgd-fo-diak')) return;
  var mozgasKevesebb = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  customElements.define('lgd-fo-diak', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.diak = Array.prototype.slice.call(this.querySelectorAll('.lgd-fo-nyito__dia'));
      this.pottyok = Array.prototype.slice.call(this.querySelectorAll('[data-potty]'));
      this.aktiv = 0;
      this.ido = parseInt(this.dataset.ido || '0', 10) * 1000;
      this.megallitva = false;
      if (this.diak.length < 2) return;

      this.pottyok.forEach(function (p) { p.addEventListener('click', function () { self.mutat(parseInt(p.dataset.potty, 10), true); }); });
      var elozo = this.querySelector('[data-elozo]'), kov = this.querySelector('[data-kovetkezo]');
      if (elozo) elozo.addEventListener('click', function () { self.mutat(self.aktiv - 1, true); });
      if (kov) kov.addEventListener('click', function () { self.mutat(self.aktiv + 1, true); });

      this.addEventListener('mouseenter', function () { self.megallitva = true; });
      this.addEventListener('mouseleave', function () { self.megallitva = false; });
      this.addEventListener('focusin', function () { self.megallitva = true; });
      this.addEventListener('focusout', function () { self.megallitva = false; });

      var kezdX = null, kezdY = null;
      this.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') { kezdX = e.clientX; kezdY = e.clientY; } });
      this.addEventListener('pointerup', function (e) {
        if (kezdX === null) return;
        var dx = e.clientX - kezdX, dy = e.clientY - kezdY;
        kezdX = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) self.mutat(self.aktiv + (dx < 0 ? 1 : -1), true);
      });

      this.blokkValaszt = function (e) {
        var i = self.diak.indexOf(e.target.closest ? e.target.closest('.lgd-fo-nyito__dia') : null);
        if (i > -1) { self.mutat(i, false); self.megallitva = true; }
      };
      document.addEventListener('shopify:block:select', this.blokkValaszt);

      if (this.ido > 0 && !mozgasKevesebb && !window.Shopify?.designMode) {
        this.idozito = setInterval(function () {
          if (!self.megallitva && !document.hidden) self.mutat(self.aktiv + 1, false);
        }, this.ido);
      }
    }

    disconnectedCallback() {
      clearInterval(this.idozito);
      if (this.blokkValaszt) document.removeEventListener('shopify:block:select', this.blokkValaszt);
    }

    mutat(i, kezzel) {
      var n = this.diak.length;
      i = (i + n) % n;
      if (i === this.aktiv) return;
      this.diak.forEach(function (d, k) {
        var be = k === i;
        d.classList.toggle('is-aktiv', be);
        if (be) d.removeAttribute('inert'); else d.setAttribute('inert', '');
      });
      this.pottyok.forEach(function (p, k) {
        p.classList.toggle('is-aktiv', k === i);
        if (k === i) p.setAttribute('aria-current', 'true'); else p.removeAttribute('aria-current');
      });
      this.diak[i].querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      this.aktiv = i;
      if (kezzel && this.idozito) { clearInterval(this.idozito); this.idozito = null; }
    }
  });
})();
